import {
  Button,
  ResponsiveModalContent,
  ResponsiveModalFooter,
  ResponsiveModalHeader,
} from '@bridebook/aura';
import { Share } from '@bridebook/aura/src/icons';
import { RsvpList } from '@bridebook/web/components/wedding-website/rsvp/rsvp-list/rsvp-list';
import { useGuestCommsRedirectShareModal } from '@bridebook/web/lib/inbox/hooks/use-guest-comms-redirect-share-modal';
import { useRsvpDeadlineForm } from '@bridebook/web/lib/wedding-website/hooks/use-rsvp-deadline-form';
import { useTranslation } from 'next-i18next';
import { useRsvpPreviewWithPublishGuard } from '@bridebook/web/lib/wedding-website/hooks/use-rsvp-preview-with-publish-guard';
import { FormProvider } from 'react-hook-form';

export const Rsvp = () => {
  const { t } = useTranslation('weddingWebsite');
  const openPreviewModal = useRsvpPreviewWithPublishGuard();
  const deadlineForm = useRsvpDeadlineForm();
  const openShareModal = useGuestCommsRedirectShareModal(true);

  return (
    <>
      <ResponsiveModalHeader>{t('website.rsvp.pageTitle')}</ResponsiveModalHeader>
      <ResponsiveModalContent>
        <FormProvider {...deadlineForm}>
          <RsvpList />
        </FormProvider>
      </ResponsiveModalContent>
      <ResponsiveModalFooter>
        <Button
          variant="secondary"
          onClick={openPreviewModal}
          className="flex-1 xl:min-w-[140px] xl:flex-none">
          {t('rsvp.form.button.preview')}
        </Button>
        <Button
          icon={Share}
          onClick={openShareModal}
          className="flex-1 xl:min-w-[140px] xl:flex-none">
          {t('rsvp.form.button.share')}
        </Button>
      </ResponsiveModalFooter>
    </>
  );
};
